<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20">
  <path d="M7 0C3.13 0 0 3.13 0 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7ZM2 7c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C4.92 14.21 2 9.85 2 7Z" fill="currentColor"/>
  <path d="M7 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="currentColor"/>
</svg>
